<template>
  <div class="message-storage-container scrollbar px-2">
    <div
      v-for="(link, index) in messages"
      :key="index"
      @click="newTab(JSON.parse(link.content).href)">
      <div class="d-flex align-items-center z2-img-container my-2 pointer">
        <img
          :src="JSON.parse(link.content).thumb || '/assets/icon/link.png'"
          style="width: 32px; height: 32px; border-radius: 4px" />
        <div class="d-flex flex-column ms-2">
          <span
            class="font-14 fw-500 trim-text-1-line"
            style="max-width: 230px">
            {{ JSON.parse(link.content).description }}
          </span>
          <span class="fw-300">{{ JSON.parse(JSON.parse(link.content).params).src }} · {{ timestampToDatetime(link.ts) }}</span>
        </div>
        <div
          class="btn-more"
          @click.stop.prevent="copyLink(JSON.parse(link.content).href)">
          <IconV2
            name="v2-link"
            color="#3484F0" />
        </div>
      </div>
      <el-divider class="my-0" />
    </div>
    <div v-if="messages.length >= round * 40" style="display: flex; justify-content: center; align-items: center;" @click="loadMoreImage">
      <el-button class="justify-content-between align-items-center" size="small">Tải thêm</el-button>
    </div>
    <!-- <div
      v-if="selectedMessages.length"
      class="px-12 d-flex flex-1 align-items-center justify-content-between border-top"
      style="width: 300px; z-index: 999; position: fixed; bottom: 0; height: 48px; background-color: white">
      <span class="font-14 text-grey600">Đã chọn: {{ selectedMessages.length }}</span>
      <div class="d-flex align-items-center">
        <div
          @click="downloadMessage"
          class="z2-btn-status-off z2-btn-circle-small me-2">
          <IconV2 name="v2-import" />
        </div>
        <div
          @click="forwardMultiMessage"
          class="z2-btn-status-off z2-btn-circle-small">
          <IconV2 name="v2-share" />
        </div>
        <el-divider
          direction="vertical"
          class="p-0" />
        <div
          @click="deleteMessage"
          class="z2-btn-status-off z2-btn-circle-small">
          <IconV2
            name="icon-trash"
            color="#CF4343" />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["messages", "conversation", "selectMulti"],
  data() {
    return {
      round: 1,
    };
  },
  computed: {
    selectedMessages() {
      return this.messages.filter((mess) => mess.select);
    },
  },
  methods: {
    timestampToDatetime(ts) {
      return moment(Number(ts)).format("DD/MM/YYYY");
    },
    selectMessage(img) {
      this.$set(img, "select", !img.select);
    },
    resetSelect() {
      this.messages.forEach((mess) => {
        this.$set(mess, "select", false);
      });
    },
    shareFile() {},
    forwardMultiMessage() {},
    deleteMessage() {
      this.resetSelect();
      this.$emit("reset");
    },
    copyLink(link) {
      const el = document.createElement("textarea");
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Sao chép thành công!");
    },
    loadMoreImage() {
      this.round += 1;
      this.$emit('loadMoreImg', this.round);
    }
  },
};
</script>

<style lang="scss" scoped>
.message-storage-container {
  height: calc(100vh - 125px) !important;
  overflow-y: auto;
}
.z2-file-container {
  position: relative;
  .btn-forward {
    right: 6px;
  }
  .btn-forward-file {
    display: none;
    position: absolute;
    background-color: #f4f5f9;
    top: 16px;
    right: 6px;
    padding: 1px;
    border-radius: 4px;
  }
}

.z2-file-container:hover {
  .btn-forward-file {
    display: block;
  }
}
</style>